<template>
  <div v-if="$store.state.user.is_god" class="selection-shop-id">
    <SelectionOptionIcon class="selection-shop-current-icon" :src="selectedShopLogo" :alt="$t(selectedShopName)" :text="$t(isGlobalSelection || (allSel && !form.shop_id) ? 'ALL' : '')" />
    <UiSelect
      v-model="form.shop_id"
      :filterable="isWebClient"
      size="medium"
      :placeholder="$t(allSel === true ? '所有商铺' : '请选择，也可输入搜索')"
      :popper-append-to-body="popperAppendToBody"
      popper-class="selection-shop-dropdown"
      @input="updateShopId"
    >
      <el-option v-if="includeGlobal && $store.state.user.is_god" :label="$t('全部店铺')" value="__all_shops__">
        <span class="selection-shop-option">
          <SelectionOptionIcon text="ALL" />
          <span>{{ $t("全部店铺") }}</span>
        </span>
      </el-option>
      <el-option v-if="allSel === true && shopList.length > 1" :label="$t('所有商铺')" value="">
        <span class="selection-shop-option">
          <SelectionOptionIcon text="ALL" />
          <span>{{ $t("所有商铺") }}</span>
        </span>
      </el-option>
      <el-option v-for="item in shopList" :key="item.id" :label="item.name" :value="item.shop_id">
        <span class="selection-shop-option">
          <SelectionOptionIcon :src="getShopLogo(item)" :alt="item.name" />
          <span>{{ item.name }}</span>
        </span>
      </el-option>
    </UiSelect>
  </div>
</template>

<script>
import SelectionOptionIcon from '@/components/SelectionOptionIcon'

export default {
  name: 'SelectionShopId',
  components: { SelectionOptionIcon },
  props: {
    value: [String, Number], // 接收父级的值作为 prop
    // 仅业务明确支持公共数据时启用；不同于 allSel 的“取消商铺筛选”。
    includeGlobal: { type: Boolean, default: false },
    allSel: { // 是否显示 所有商铺选项
      type: Boolean,
      default: false
    },
    popperAppendToBody: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      form: {
        shop_id: this.resolveShopId(this.value)
      }
    }
  },
  computed: {
    isGlobalSelection () {
      return this.includeGlobal && this.$store.state.user.is_god && this.form.shop_id === '__all_shops__'
    },
    // 获取商铺列表
    shopList () {
      return this.$store.state.shopList
    },
    selectedShop () {
      return this.shopList.find(item => String(item.shop_id) === String(this.form.shop_id)) || null
    },
    selectedShopLogo () {
      return this.getShopLogo(this.selectedShop)
    },
    selectedShopName () {
      if (this.isGlobalSelection) return '全部店铺'
      return this.selectedShop ? this.selectedShop.name : (this.allSel ? '所有商铺' : '请选择商铺')
    },
    /**
     * @description: 终端平台是否是pc
     */
    isWebClient () {
      return this.$store.getters['app/getIsWebClient']
    }
  },
  watch: {
    value (val) {
      const nextShopId = this.resolveShopId(val)
      if (typeof nextShopId !== 'undefined' && nextShopId !== this.form.shop_id) {
        this.form.shop_id = nextShopId
      }
    },
    shopList () {
      if (!this.form.shop_id && !this.allSel && !this.value) {
        this.form.shop_id = this.resolveShopId(this.value)
      }
      this.updateShopId()
    }
  },
  created () {
    if (this.shopList.length > 0 || this.isGlobalSelection) {
      this.updateShopId()
    }
  },
  methods: {
    resolveShopId (value) {
      if (!this.$store.state.user.is_god) return this.$store.state.user.shop_id || ''
      if (value !== '' && value !== null && typeof value !== 'undefined') return value
      if (this.allSel) return ''
      const ownShopId = this.$store.state.user.shop_id
      if (ownShopId !== '' && ownShopId !== null && typeof ownShopId !== 'undefined') return ownShopId
      const firstShop = (this.$store.state.shopList || [])[0]
      return firstShop ? firstShop.shop_id : ''
    },
    getShopLogo (shop) {
      if (!shop) return ''
      if (Array.isArray(shop.logo)) return shop.logo[0] || ''
      return typeof shop.logo === 'string' ? shop.logo : ''
    },
    updateShopId () {
      if (!this.$store.state.user.is_god) {
        this.form.shop_id = this.$store.state.user.shop_id || ''
      }
      this.$emit('input', this.form.shop_id) // 发送 input 事件给父级
    }
  }
}
</script>

<style lang="scss" scoped>
.selection-shop-id {
  width: 240px;
  max-width: 100%;
  position: relative;
}

.selection-shop-id ::v-deep .el-input__inner {
  height: var(--ui-control-height) !important;
  padding-left: 42px;
  line-height: var(--ui-control-height) !important;
}

.selection-shop-id ::v-deep .el-input__suffix,
.selection-shop-id ::v-deep .el-input__icon {
  height: var(--ui-control-height);
  line-height: var(--ui-control-height);
}

.selection-shop-current-icon {
  position: absolute;
  top: 8px;
  left: 9px;
  z-index: 2;
  pointer-events: none;
}
</style>

<style lang="scss">
.selection-shop-dropdown .selection-shop-option {
  display: flex;
  align-items: center;
  gap: var(--ui-space-sm);
}

.selection-shop-dropdown[x-placement^="bottom"] {
  margin-top: var(--ui-space-xs) !important;
}

.selection-shop-dropdown[x-placement^="top"] {
  margin-bottom: var(--ui-space-xs) !important;
}

.selection-shop-dropdown .el-select-dropdown__item {
  height: 40px;
  line-height: 40px;
}

</style>
